/**
 * URL building helpers for createAuth
 * Extracted to reduce function size
 */

import type { IBaseApiService } from "@Front/Api/BaseApiServiceFactory";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

function sanitizeUrl(value: string): string {
	return value.replace(/([^:])\/{2,}/g, "$1/");
}

function trimTrailingSlash(value: string): string {
	return value.replace(/\/+$/, "");
}

/**
 * Builds backend URL for auth operations (uses {@link IBaseApiService.getBaseUrl} so host rewrite matches API client).
 */
export function buildBackendUrl(baseApi: IBaseApiService, pathname: string): URL {
	const base = trimTrailingSlash(baseApi.getBaseUrl());
	const target = sanitizeUrl(`${base}/${pathname.replace(/^\//, "")}`);

	try {
		return new URL(target);
	} catch (error) {
		LoggerService.error("[Auth] Failed to build backend URL", {
			pathname,
			target,
			error,
		});
		throw error;
	}
}
